module.exports = __webpack_public_path__ + "img/152.f9b79800.jpg";